import { Box } from '@wix/design-system';
import React from 'react';
import { useIsMobile } from '../../hooks';
export const TrustBuilderBanner = ({ gap, children, }) => {
    const isMobile = useIsMobile();
    const filteredChildren = React.Children.toArray(children).filter((child) => child);
    return (React.createElement(Box, { width: "100%", direction: isMobile ? 'vertical' : 'horizontal', gap: gap ?? isMobile ? 'SP4' : 'SP7', verticalAlign: "middle", align: "space-between" }, filteredChildren.map((child, idx) => {
        const shouldShowDivider = !isMobile && idx < filteredChildren.length - 1;
        const align = isMobile
            ? 'center'
            : filteredChildren.length === 2
                ? idx === 0
                    ? 'right'
                    : 'left'
                : 'center';
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { width: "100%", flex: 1, align: align, key: idx }, child),
            shouldShowDivider && (React.createElement(Box, { width: "1px", backgroundColor: "#DFE5EB", height: "36px", key: `div-${idx}` }))));
    })));
};
//# sourceMappingURL=TrustBuilderBanner.js.map